export const GET_SUPER_ADMIN_SERVICES_LIST = null;